<section class="content tab-section d-flex">
  <div class="content-block flex-grow-1 d-flex flex-column">
    <div class="  d-flex flex-column ">
      <div class="d-flex justify-content-between flex-wrap">
        <div class="search-cont">
          <div class="s-in form-input" >
            <mat-icon class="input-icon">search</mat-icon>
            <input  type="text" placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control" [(ngModel)]="searchInput"    (input)="onSearch($event)" (keyup.enter)="onGo()"/>
          </div>
          <div class="go-b" (click)="onGo()">{{'COMMON.GO' | translate}}</div>
          <div class="s-item d-box " (click)="onFilterView()">
            <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
          </div>
        </div>
        <button mat-raised-button color="primary" class=" primary-btn s-lbtn  mb-2 mb-md-0 course-btn no-sh-btn" type="submit"
          (click)="onAddEditForum('')">
          <i class="fas fa-plus text-white"></i> {{'COMMON.ADD' | translate}} {{'MENUITEMS.FORUMMANAGEMENT.FORUM' | translate}}</button>
      </div>
      <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
      <div class="heading-2 new-h mt-3">
        <div class="s-bt" (click)="onAddEditForum('')"> <i class="fas fa-plus text-white"></i> {{'COMMON.ADD' | translate}} {{'MENUITEMS.FORUMMANAGEMENT.FORUM' | translate}}</div>
      </div>

    </div>
    <div *ngIf="!isSpinnerLoading" class="d-flex flex-column flex-grow-1">
      <div class="course-cont d-flex mt-2 flex-wrap" *ngIf="filteredItems.length==0">
        <div class="mat-table__message">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>
      <div class="flex-grow-1">
        <div class="row mt-3 ">
          <div class="col-md-6 col-xl-4 mb-3 mb-sm-4 forum-cont " *ngFor="let item of filteredItems">
            <div class="f-box d-flex  h-100">
            
              <div class="f-img" [appBackgroundImg]="item.img" iType="forum"></div>
              <div class="f-cont d-flex flex-grow-1 ">
                <div class="position-relative width d-flex flex-column">

                  <i class="material-icons cursor-pointer more-icon" [matMenuTriggerFor]="menu">more_vert</i>
                  <mat-menu #menu="matMenu">

                    <div class="menu">
                      <div class="action-icon  me-2" (click)="onAddEditForum(item)" matTooltip="{{'COMMON.EDIT' | translate}}">
                        <img src="assets/images/icons/edit-icon.svg" alt="">
                        <div class="menu-txt">{{'COMMON.EDIT' | translate}}</div>
                      </div>

                      <div class="action-icon  " (click)="onDeleteForum(item.id)" matTooltip="{{'BUTTON.DELETE' | translate}}">
                        <img src="assets/images/icons/delete-icon.svg" alt="">
                        <div  class="menu-txt mt-1">{{'BUTTON.DELETE' | translate}}</div>
                      </div>
                    </div>

                  </mat-menu>
                  <div class="text-black me-1">{{item.tit | truncate:20}}</div>
                  <div class="f-desc flex-grow-1 pt-1" [innerHTML]="item.desc | truncate:74:'desc'"></div>
                   
                   <div class="d-flex align-items-center date-div flex-wrap pt-1">
                    <div class="small-text d-flex align-items-center me-1"> <img src="assets/images/icons/date.svg"  class="pe-1"alt="">{{"COMMON.PUBDATE" | translate}}: </div>
                    <div class=" box-title text-medium"> {{item.c_ti | dates}}</div>
                   </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-cont" *ngIf="filteredItems.length!=0">
        <div class=" show-item">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
            [(ngModel)]="config.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="page-c">
          <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
            [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
      </div>
    </div>
    <div class="tab-content flex-grow-1 white-bg d-flex align-items-center justify-content-center"
      style="position: relative" *ngIf="isSpinnerLoading">
      <div class="custom-loader"></div>
    </div>
  </div>
</section>
